import { createFileRoute } from "@tanstack/react-router";
import { SettingsPage } from "src/pages/Settings/SettingsPage";

export const Route = createFileRoute("/settings")({
	component: SettingsPage,
});
